module.exports = __webpack_public_path__ + "media/images/sports_icons/dance-ef2c64d0003a0f7b4aa29f778c9b939f.png";